import { isObject } from 'lodash';

export function deepOmitUndefined<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(deepOmitUndefined) as unknown as T;
  } else if (obj instanceof Date) {
    return obj;
  } else if (isObject(obj)) {
    return Object.entries(obj)
      .filter(([, v]) => v !== undefined)
      .reduce(
        (acc, [k, v]) => ({
          ...acc,
          [k]: deepOmitUndefined(v),
        }),
        {},
      ) as unknown as T;
  }

  return obj;
}
